import type { Comment } from "./comment.type";

import { format, humanizeDate } from "@/utilities/date";

export const getCommentDate = (comment: Comment) => {
  const date = comment.created_at;

  if (!date) return {};

  return {
    dateString: format(date, "YYYY-MM-DD HH:mm:ss"),
    dateHumanized: humanizeDate(date),
  };
};
